<!--
 * @Description:
 * @Author: 李方强
 * @Date: 2020-10-12 16:00:18
 * @LastEditTime: 2021-12-01 14:42:11
 * @LastEditors: lkz
-->
<template>
  <div id="new-compensate">
    <el-form :label-position="labelPosition" label-width="108px" :rules="afterSaleFormRules" :model="afterSaleForm"
      ref="shouhouQueryFrom" style="overflow: hidden;">
      <el-form-item label="线索">
        <el-select v-model="afterSaleForm.compensateType" style="width: 100px" placeholder="请选择">
          <el-option v-for="item in clueOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-input style="width:250px;" v-model="afterSaleForm.receiptNo"></el-input>
        <el-button class="btns" type="primary" @click="getOrderInfo(1)">查询</el-button>
        <div class="goods-wrapper" v-show="!isPhone">
          <!-- 订单商品勾选列表 -->
          <table class="googs_table" v-if="orderObj.orderItemBo">
            <tbody v-for="(item, index) in orderObj.orderItemBo" :key="index">
              <tr>
                <td>
                  <div class='elradio'>
                    <el-radio v-model="itemId" :label="item.subOrderId" v-show="!item.tuDetails"
                      @change="setitems(item, 1)" style="padding-top: 25px">
                    </el-radio>
                    <i class="el-icon-caret-bottom" :class="{ 'active': !tuShow['isTuShow' + index] }" v-if="item.tuDetails"
                      @click="handleToggle(index)">
                    </i>
                  </div>
                  <div class="goods-info-wrapper">
                    <div class="info-wrapper-flex">
                      <img :src="item.itemImg" alt="">
                      <div class="goods-info">
                        <h4><span>{{ item.itemName }}</span><label>￥{{ item.itemPrice }}</label></h4>
                        <p><span>规格：{{ item.itemModel }}</span><label>x{{ item.buyCount }}</label>
                        </p>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-for='(itemT, indexT) in item.tuDetails' :key='indexT'
                v-show='item.tuDetails && tuShow["isTuShow" + index]'>
                <td>
                  <div class='elradio'>
                    <el-radio v-model="itemId" :label="itemT.subOrderId" style="padding-top: 25px"
                      @change="setitems(item, 2, itemT)"></el-radio>
                  </div>
                  <div class="goods-info-wrapper">
                    <div class="info-wrapper-flex">
                      <img :src="itemT.itemImg" alt="">
                      <div class="goods-info">
                        <h4><span>{{ itemT.itemName }}</span><label>￥{{ itemT.itemPrice }}</label></h4>
                        <p><span>规格：{{ itemT.itemModel }}</span><label>x{{ itemT.buyCount }}</label>
                        </p>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- 订单退货物流勾选列表 -->
          <div class="googs_list" v-if="orderObj.logisticsBeanList">
            <div v-for="(item, index) in orderObj.logisticsBeanList" :key="index">
              <el-radio @change="setitems(item)" v-model="itemId" :label="item.returnId"></el-radio>
              <div class="googs_list-right">
                <p>快递单号：{{ item.wuLiuId }}({{ item.wuLiuName }})</p>
                <p style="color: #ccc">售后单号：{{ item.returnId }}({{ getOrderStatus(item.returnStatus) }})</p>
              </div>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="补偿原因" prop="compensateReason">
        <el-cascader style="width: 422px" v-model="afterSaleForm.compensateReason" :options="causeOptions"
          @change="getCompensateReasonChange" :props="causeProps">
        </el-cascader>
        <i v-show="isExplain" class="el-icon-question explain-icon" @click="getExplain"></i>
      </el-form-item>
      <div v-show="isShow">
        <div class="rule-description">
          <div class="rule-description-box">
            <span class="box-left">规则说明：</span>
            <div class="box-right" v-show="explain.ruleExplain">{{ explain.ruleExplain }}</div>
            <div class="box-right" v-show="!explain.ruleExplain">暂无</div>
          </div>
          <div class="rule-description-box">
            <span class="box-left">补偿标准：</span>
            <div class="box-right">
              {{ explain.compensateText }}
              <span>{{ explain.guideText }}</span>
              <!-- 价保金额计算 -->
              <priceProtectionCalculationTool :orgOrderId="afterSaleForm.receiptNo" :orgSubOrderId="itemId"
                @fillAmount="fillAmount" v-if="afterSaleForm.compensateType === 1 &&
                  afterSaleForm.compensateReason.length &&
                  (afterSaleForm.compensateReason.includes(7213) || afterSaleForm.compensateReason.includes(7214))">
              </priceProtectionCalculationTool>
              <!-- 常规金额计算 -->
              <el-popover v-else-if="!isPhone" placement="top" title="补偿金额计算" width="600" trigger="click">
                <div class="calculate-money">
                  <h6>商品金额=订单商品总金额+运费+税费</h6>
                  <div class="table-money">
                    <div class="table-left">
                      <div class="table-left-list">
                        <p>补偿数量</p>
                        <el-input size="mini" v-model="compensateNum"></el-input>
                      </div>
                      <i> ÷ </i>
                      <div class="table-left-list">
                        <p>购买数量</p>
                        <el-input size="mini" v-model="buyCount"></el-input>
                      </div>
                      <i> x 商品金额 = ¥</i>
                      <div class="table-left-list">
                        <p>补偿金额</p>
                        <el-input size="mini" v-model="compensateMoney"></el-input>
                      </div>
                    </div>
                    <div class="table-right">
                      <el-button type="primary" size="mini" @click="getCalculate">计算</el-button>
                      <el-button type="primary" size="mini" @click="getFill">填入</el-button>
                    </div>
                  </div>
                </div>
                <i class="box-right-money" slot="reference">金额计算</i>
              </el-popover>
            </div>
          </div>
        </div>
        <el-col :span="24">
          <el-form-item label="总补偿金额" prop="compensateTotalMoney">
            <el-input style="width: 136px" v-model.trim="afterSaleForm.compensateTotalMoney"></el-input> 元
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="补偿方式" prop="compensateMode">
            <div class="compensation-way" style="display: flex;padding-top:10px">
              <el-radio style="margin-left: 0" v-show="explain.compensateMode.indexOf(0) > -1"
                v-model="afterSaleForm.compensateMode" :label="0">云币</el-radio>
              <el-radio style="margin-left: 0" v-show="explain.compensateMode.indexOf(2) > -1"
                v-model="afterSaleForm.compensateMode" :label="2">优惠券</el-radio>
              <el-radio style="margin-left: 0" v-show="explain.compensateMode.indexOf(1) > -1"
                v-model="afterSaleForm.compensateMode" :label="1">余额</el-radio>
            </div>
            <!-- <i class="el-icon-question"></i> -->
          </el-form-item>
        </el-col>
        <!-- compensateMode:2  优惠券  ;0是云币 -->
        <el-col :span="12" v-show="afterSaleForm.compensateMode === 0">
          <el-form-item label="有效期" prop="moneyValidTime">
            <el-select style="width: 136px" v-model="afterSaleForm.moneyValidTime" placeholder="请选择">
              <el-option v-for="item in dateOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- compensateMode:2  优惠券  ;0是云币 ; targetId ==0 美食团-->
        <el-col :span="12" v-show="afterSaleForm.compensateMode === 2 && targetId === 6">
          <el-form-item label="有效期" prop="moneyValidTime">
            <el-select style="width: 136px" v-model="afterSaleForm.moneyValidTime" placeholder="请选择">
              <el-option v-for="item in timeOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="发放账户" prop="compensateAccountType">
            <el-radio style="margin-left: 0" v-show="explain.compensateAccountType.indexOf(0) > -1"
              v-model="afterSaleForm.compensateAccountType" :label="0">买家</el-radio>
            <el-radio style="margin-left: 0" v-show="explain.compensateAccountType.indexOf(1) > -1"
              v-model="afterSaleForm.compensateAccountType" :label="1">卖家</el-radio>
            <el-radio style="margin-left: 0" v-show="explain.compensateAccountType.indexOf(2) > -1"
              v-model="afterSaleForm.compensateAccountType" :label="2">买家</el-radio>
            <el-radio style="margin-left: 0" v-show="explain.compensateAccountType.indexOf(3) > -1"
              v-model="afterSaleForm.compensateAccountType" :label="3">卖家</el-radio>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="补偿说明" prop="compensateDesc">
            <el-input style="width: 413px" type="textarea" :rows="3" maxlength="512" show-word-limit placeholder="请输入内容"
              v-model="afterSaleForm.compensateDesc">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item class="skill-input-wrapper" label="图片地址:">
            <work-upload @uploadImg='workImgs'></work-upload>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="图片凭证" prop='compensateImages'>
            <div class='imgList'>
              <span v-for="(item, index) in afterSaleForm.compensateImages" :key="index">
                <img :src="item" alt="" @click="showimg(index)">
                <i class="el-icon-error" @click="delbtnpic(index)"></i>
              </span>
            </div>
            <el-upload v-show='afterSaleForm.compensateImages && afterSaleForm.compensateImages.length < 5'
              style='display:inline' action="/yunjixinyunadmin/admin/xinyun/upload/uploadPic_json.json"
              list-type="picture-card" name="data" :drag='true' :limit='5' accept=".jpg,.png"
              :on-success="handlePictureCardPreview" :show-file-list="false">
              <i class="el-icon-plus"></i>
            </el-upload>
            <div class="line-tip">最多支持5张，图片仅支持jpg和png格式，单张图片不要超过5M</div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-button type="primary" style="display: block; margin: 0 auto" :disabled="isDisabled"
            @click="submitShouhouForm('afterSaleForm', true, true, true)" v-preventReClick>确认创建</el-button>
        </el-col>
      </div>
    </el-form>
    <viewer :images="afterSaleForm.compensateImages" ref="viewerRef" :options="{ title: false, zIndex: 9999 }">
      <img v-show="false" v-for="src in afterSaleForm.compensateImages" :src="src" :key="src">
    </viewer>
    <!-- 查看原因 -->
    <el-dialog title="查看原因" :visible.sync="explainVisible" width="400px">
      <el-form ref="explainForm" :model="explainForm" label-width="100px">
        <el-form-item label="选择原因">
          <el-select v-model="explainForm.region" @change="getExplainChange">
            <el-option v-for="(item, index) in explainList" :key="index" :label="item.ruleDataResp.reasonName"
              :value="item.ruleDataResp.reasonId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否可选">
          <span>{{ explainForm.choose ? '是' : '否' }}</span>
        </el-form-item>
        <el-form-item label="不可选原因">
          <span>{{ explainForm.desc }}</span>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 同图弹窗 -->
    <figureDialog @cellClick='cellClick' @handleSave='handleSave' ref="figureDialog" :title='"确认提示"' :dialogtype='1'>
    </figureDialog>
  </div>
</template>
<script>
import Viewer from 'v-viewer/src/component.vue'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'viewerjs/dist/viewer.css'
import cache from '@/utils/formCache'
import figureDialog from '@/views/invoices/voucher/addCompensate/figureDialog'
import * as http from './compensate.service'
import workUpload from '../../components/workUpload'
import priceProtectionCalculationTool from './priceProtectionCalculationTool.vue'
// 同图弹窗

export default {
  components: {
    Viewer,
    workUpload,
    priceProtectionCalculationTool,
    figureDialog
  },
  data() {
    const numReg = /^([0-9]*)(\.[0-9]{1,2})?$/
    const validateCompensateTotalMoney = (rule, value, callback) => {
      if (value <= 0) {
        callback(new Error('请输入总补偿金额,需大于0'))
      } else if (!numReg.test(value)) {
        callback(new Error('请输入不超过2位小数的正数'))
      } else {
        callback()
      }
    }
    return {
      priceMoney: 0,
      intercept: false,
      flage: true,
      itemId: '',
      labelPosition: 'right',
      afterSaleForm: {
        compensateType: 1,
        receiptNo: '', // 线索id
        compensateReason: '',
        compensateMoney: '',
        compensateTotalMoney: '',
        compensateMode: 2,
        moneyValidTime: null,
        compensateAccountType: 2,
        compensateDesc: '',
        compensateImages: []
      },
      afterSaleFormRules: {
        compensateDesc: [
          { required: true, message: '请输入补偿说明', trigger: 'blur' }
        ],
        compensateImages: [
          { required: true, message: '请上传图片凭证', trigger: 'change' }
        ],
        compensateAccountType: [
          { required: true, message: '请选择发放账户', trigger: 'change' }
        ],
        moneyValidTime: [
          { required: true, message: '请选择云币有效期', trigger: 'change' }
        ],
        compensateMode: [
          { required: true, message: '请选择补偿方式', trigger: 'change' }
        ],
        compensateTotalMoney: [
          { required: true, validator: validateCompensateTotalMoney, trigger: 'blur' }
        ],
        // compensateMoney: [
        //   { required: true, message: '请输入标准补偿金额', trigger: 'blur' }
        // ],
        compensateReason: [
          { required: true, message: '请选择补偿原因', trigger: 'blur' }
        ]
      },
      isDisabled: false,
      // 云币有效期
      dateOptions: [
        {
          label: '1天',
          value: 100
        }, 
        // {
        //   label: '7天',
        //   value: 200
        // }, {
        //   label: '15天',
        //   value: 300
        // }, 
        {
          label: '30天',
          value: 400
        }, {
          label: '90天',
          value: 500
        }
      ],
      // 美食团有效期
      timeOptions: [
        {
          label: '1天',
          value: 1
        }, {
          label: '7天',
          value: 2
        }, {
          label: '15天',
          value: 3
        }, {
          label: '30天',
          value: 4
        }, {
          label: '90天',
          value: 5
        }, {
          label: '180天',
          value: 6
        }, {
          label: '1年',
          value: 7
        }
      ],
      causeOptions: [],
      causeProps: {
        value: 'reasonId',
        label: 'reasonName',
        children: 'childReasons'
      },
      clueOptions: [
        {
          label: '订单商品',
          value: 1
        }, {
          label: '手机号',
          value: 2
        }, {
          label: '订单退货物流',
          value: 3
        }
      ],
      orderObj: {
        orderItemBo: [],
        logisticsBeanList: []
      }, // 补偿信息列表
      radio: '1',
      explain: {
        ruleExplain: '',
        compensateText: '',
        guideText: '',
        compensateMode: [1, 2],
        compensateAccountType: [0, 1],
        compensateDesc: 2,
        compensateImage: 2,
        maxMoney: 0
      },
      receiptNo: '',
      receiptSubNo: '',
      receiptChildNo: '',
      compensateNum: '',
      buyCount: '',
      compensateMoney: '',
      isShow: false,
      subOrderId: '',
      isPhone: false,
      explainVisible: false, // 查看原因
      explainForm: {
        region: '',
        choose: true,
        desc: ''
      },
      isExplain: false, // 是否显示查看原因
      explainList: [], // 原因列表
      orderReturnStatusEnum: [ // 售后状态
        {
          code: '13',
          name: '待确认'
        }, {
          code: '0',
          name: '待客服审核'
        }, {
          code: '5',
          name: '待商户审核'
        }, {
          code: '14',
          name: '待修改申请'
        }, {
          code: '11',
          name: '待寄回退货'
        }, {
          code: '12',
          name: '待确认收货'
        }, {
          code: '16',
          name: '驳回待修改'
        }, {
          code: '1',
          name: '售后待完成'
        }, {
          code: '4',
          name: '退款失败'
        }, {
          code: '15',
          name: '退款中'
        }, {
          code: '2',
          name: '售后完成'
        }, {
          code: '3',
          name: '售后关闭'
        },
        {
          code: '26',
          name: '商品寄回待退款'
        },
        {
          code: '30',
          name: '退款中'
        },
        {
          code: '32',
          name: '退款失败'
        },
        {
          code: '31',
          name: '已退款'
        },
        {
          code: '27',
          name: '商品寄回审核不通过'
        },
        {
          code: '10',
          name: '待团长审核'
        },
        {
          code: '11',
          name: '团长审核不通过'
        },
        {
          code: '20',
          name: '待客服确认审核'
        },
        {
          code: '21',
          name: '客服审核不通过'
        },
        {
          code: '22',
          name: '客服审核通过'
        },
        {
          code: '25',
          name: '待寄回商品'
        },
        {
          code: '50',
          name: '已取消'
        }
      ],
      targetId: 0, // 6-美食团订单
      saveParams: {},
      tuShow: {}
    }
  },
  props: {
    sumbit: {
      type: Function
    }
  },
  methods: {
    // 初始化
    getInfo(orderId, subOrderId, targetId) {
      this.afterSaleForm.receiptNo = orderId
      this.subOrderId = subOrderId
      this.targetId = targetId
      this.$refs.shouhouQueryFrom.resetFields()
      if (this.targetId === 6) {
        this.afterSaleForm.moneyValidTime = 4
      } else {
        this.afterSaleForm.moneyValidTime = 400
      }
      this.isShow = false
      this.afterSaleForm.compensateType = 1
      this.getOrderInfo(0)
    },
    // 获得售后状态
    getOrderStatus(val) {
      const data = this.orderReturnStatusEnum.find(x => x.code == val)
      return data.name
    },
    // 查询
    getOrderInfo(type, subOrderId, isSaveCauseOptions = false) { // 第二个参数，仅仅用于sop注入式的申请卜偿
      // 缓存数据
      return new Promise((resolve) => {
        const cacheData = this.afterSaleForm.compensateType !== 3 ? cache.queryCache({
          id: this.afterSaleForm.receiptNo + this.subOrderId,
          formId: 'newcompensate'
        }) : null


        if (subOrderId) {
          this.itemId = subOrderId
        }
        if (cacheData) {
          this.itemId = cacheData.itemId
          if (cacheData.compensateType === 3) {
            cacheData.compensateType = 1 // 临时兼容
          }
        } else if (!isSaveCauseOptions) this.causeOptions = []
        // 如果是手机号，则直接调用补偿原因接口
        if (this.afterSaleForm.compensateType == 2) {
          this.isPhone = true
          this.setitems().then(() => {
            resolve()
          })
        } else {
          http.preViewCompensateOrderItem({
            compensateType: this.afterSaleForm.compensateType,
            receiptNo: this.afterSaleForm.receiptNo,
            businessDomain: this.returnBusinessDomain()
          }).subscribe((res) => {
            this.isPhone = false
            this.orderObj = res.data
            // 打开弹窗默认选中相应商品 orderItemBo
            if (res.data.orderItemBo) {
              res.data.orderItemBo.forEach((item, index) => {
                if (item.subOrderId === this.subOrderId && !item.tuDetails) {
                  this.itemId = item.subOrderId
                  this.setitems(item, 1).then(() => {
                    resolve()
                  })
                } else if (item.tuDetails) {
                  // 判断tu下面的sku是否显示
                  this.$set(this.tuShow, `isTuShow${index}`, true)
                  if (this.itemId) {
                    item.tuDetails.forEach((itemTu) => {
                      if (this.itemId === itemTu.subOrderId) {
                        this.setitems(item, 2, itemTu).then(() => {
                          resolve()
                        })
                      }
                    })
                  }
                }
              })
            }
            if (res.data.logisticsBeanList && res.data.logisticsBeanList.length > 0) {
              // 默认选择第一个
              const item = res.data.logisticsBeanList[0]
              this.itemId = item.returnId
              this.setitems(item).then(() => {
                resolve()
              })
            }
            if (type === 0) {
              if (cacheData) {
                this.afterSaleForm = cacheData
                delete this.afterSaleForm.itemId
                if (this.afterSaleForm.compensateReason.length) {
                  this.getCompensateReasonChange(cacheData.compensateReason, true)
                }
                this.getCompensateApplyAutoFillPage(cacheData)
              }
            } else {
              if (!isSaveCauseOptions) this.causeOptions = []
              this.itemId = this.afterSaleForm.compensateType === 3 ? '' : this.itemId
            }
          })
        }
      })
    },
    // 自动填充逻辑
    getCompensateApplyAutoFillPage(cacheData) {
      return new Promise((resolve, reject) => {
        const params = {
          compensateType: cacheData.compensateType,
          receiptNo: cacheData.receiptNo,
          receiptSubNo: this.receiptSubNo,
          receiptChildNo: this.receiptChildNo,
          businessDomain: this.returnBusinessDomain(),
          compensateMode: cacheData.compensateMode,
          compensateAccountType: cacheData.compensateAccountType,
          moneyValidTime: cacheData.moneyValidTime,
          compensateTotalMoney: cacheData.compensateTotalMoney,
          compensateDesc: cacheData.compensateDesc,
          compensateImages: cacheData.compensateImages
        }
        if (Array.isArray(cacheData.compensateReason) && cacheData.compensateReason.length) {
          params.compensateReason = cacheData.compensateReason[cacheData.compensateReason.length - 1]
        }
        console.log('compensateReason', cacheData.compensateReason, 222, params)
        http.getCompensateApplyAutoFillPage(params).subscribe((res) => {
          // 校验compensateTemplateRo为空则return出去
          if (!res.data.compensateTemplateRo) {
            reject(0)
            return
          }
          // 校验是否为空，全部为空则return出去
          const list = ['compensateAccountType', 'compensateDesc', 'compensateImages', 'compensateMode',
            'compensateTotalMoney', 'compensateType', 'moneyValidTime', 'compensateReason']
          const result = res.data.compensateAutoFillBean || {}
          const isEmpty = this.isValueIsEmpty(result, list)
          if (!isEmpty) {
            resolve(1)
            return
          }
          this.afterSaleForm.compensateAccountType = result.compensateAccountType
          this.afterSaleForm.compensateDesc = result.compensateDesc
          this.afterSaleForm.compensateImages = result.compensateImages || []
          this.afterSaleForm.compensateMode = result.compensateMode
          this.afterSaleForm.compensateTotalMoney = result.compensateTotalMoney
          this.afterSaleForm.compensateType = result.compensateType
          this.afterSaleForm.moneyValidTime = result.moneyValidTime || 400
          this.causeOptions = res.data.compensateReasonRos.data
          //  通过末级原因，匹配到上级原因 组成的数组，赋值给compensateReason
          const reasonList = this.parentTree(res.data.compensateReasonRos.data, result.compensateReason)
          if (reasonList && reasonList.length) {
            this.afterSaleForm.compensateReason = reasonList.reverse()
          }
          resolve(2)
        }, (e) => {
          reject(e)
        })
      })
    },
    // 通过末级原因，匹配到上级原因 组成的数组
    parentTree(arr, reasonId) {
      const temp = []
      // eslint-disable-next-line
      const callback = function (nowArr, reasonId) {
        // 先定义个函数寻找子节点位置 找到后 再找改节点父元素位置 以此类推
        for (let i = 0; i < nowArr.length; i++) {
          const item = nowArr[i]
          if (item.reasonId === reasonId) {
            temp.push(item.reasonId)
            callback(arr, item.parentId) // 父级ID
            break
          } else if (item.childReasons && item.childReasons.length) {
            callback(item.childReasons, reasonId)
          }
        }
      }
      callback(arr, reasonId)
      return temp // 最后返回
    },
    // list里面的字段，只有data有一个不为空，则返回true，则取填充接口的值。否则取缓存
    isValueIsEmpty(data, list) {
      return list.some(i => data[i] !== null && data[i] !== '')
    },
    // 补偿金额计算
    getCalculate() {
      if (!(/^\+?[1-9][0-9]*$/).test(this.compensateNum)) {
        this.$message.error('补偿数量请输入正整数')
        return false
      }
      if (!(/^\+?[1-9][0-9]*$/).test(this.buyCount)) {
        this.$message.error('购买数量请输入正整数')
        return false
      }
      const params = Object.assign({}, {
        compensateType: this.afterSaleForm.compensateType,
        receiptNo: this.receiptNo,
        receiptSubNo: this.receiptSubNo,
        compensateNum: this.compensateNum,
        buyCount: this.buyCount,
        businessDomain: this.returnBusinessDomain()
      })
      http.compensateMoneyCalculate(params).subscribe((res) => {
        if (res.data) {
          this.compensateMoney = this.keepTwoDecimal(res.data.compensateMoney)
        } else {
          this.compensateMoney = 0
          this.$message.error('接口返回错误,请重新查询')
        }
      })
    },
    workImgs(val) {
      if (this.afterSaleForm.compensateImages && this.afterSaleForm.compensateImages.length >= 5) {
        this.$message.error('最多上传5张图片')
        return
      }
      if ((val.split('http')).length - 1 > 1) {
        this.$message.error('请上传正确的图片地址')
        return
      }
      if (this.afterSaleForm.compensateImages) this.afterSaleForm.compensateImages.push(val)
    },
    // 保留两位小数
    keepTwoDecimal(num) {
      let result = parseFloat(num)
      if (isNaN(result)) {
        alert('传递参数错误，请检查！')
        return false
      }
      result = Math.round(num * 100) / 100
      return result
    },
    // 填入金额
    getFill() {
      // this.afterSaleForm.compensateMoney = this.compensateMoney
      this.afterSaleForm.compensateTotalMoney = this.compensateMoney
    },
    // 补偿原因
    getCompensateReasonChange(val, isCache) {
      const param = {
        compensateType: this.afterSaleForm.compensateType,
        receiptNo: this.receiptNo,
        receiptSubNo: this.receiptSubNo,
        receiptChildNo: this.receiptChildNo,
        compensateReason: val ? val[val.length - 1] : '',
        businessDomain: this.returnBusinessDomain()
      }
      http.preViewTemplate(param).subscribe((res) => {
        this.isShow = true
        this.explain = res.data
        this.priceMoney = res.data.priceMoney || 0
        this.intercept = res.data.intercept || false
        this.flage = true
        this.afterSaleFormRules.compensateDesc[0].required = res.data.compensateDesc == 1
        this.afterSaleFormRules.compensateImages[0].required = res.data.compensateImage == 1
        this.afterSaleFormRules.moneyValidTime[0].required = res.data.compensateMode == 0
        // 返回的补偿方式无优惠券，默认选中云币
        if (!this.explain.compensateMode.includes(2) && !isCache) {
          this.afterSaleForm.compensateMode = 0
        }
        // 发放账户
        if (!this.explain.compensateAccountType.includes(2) && !isCache) { // 美食团
          this.afterSaleForm.compensateAccountType = 0
        } else if (this.explain.compensateAccountType.includes(2) && !isCache) { // 云集
          this.afterSaleForm.compensateAccountType = 2
        }
      }, () => {
        this.isShow = false
      })
    },
    // 查看原因
    getExplain() {
      this.explainVisible = true
      this.explainForm = {
        region: '',
        choose: true,
        desc: ''
      }
      const params = {
        compensateType: this.afterSaleForm.compensateType,
        receiptNo: this.receiptNo,
        receiptSubNo: this.receiptSubNo,
        receiptChildNo: this.receiptChildNo,
        businessDomain: this.returnBusinessDomain()
      }
      http.checkCompensateRule(params).subscribe((res) => {
        this.explainList = res.data
      })
    },
    getExplainChange(val) {
      const item = this.explainList.find(item => item.ruleDataResp.reasonId === val)
      this.explainForm.choose = item.choose
      this.explainForm.desc = item.desc
    },
    // 商品信息勾选
    setitems(item, type, tuItem) {
      return new Promise((resolve) => {
        if (this.afterSaleForm.compensateType == 1) {
          this.receiptNo = item.orderId
          this.receiptSubNo = item.subOrderId
          this.receiptChildNo = type == 2 ? tuItem.subOrderId : null
        } else if (this.afterSaleForm.compensateType == 2) {
          this.receiptNo = this.afterSaleForm.receiptNo
          this.receiptSubNo = this.afterSaleForm.receiptNo
          this.receiptChildNo = this.afterSaleForm.receiptNo
        } else {
          this.receiptNo = this.afterSaleForm.receiptNo
          this.receiptSubNo = item.returnId
          this.receiptChildNo = item.wuLiuId
          this.isExplain = true
        }
        const params = {
          compensateType: this.afterSaleForm.compensateType,
          receiptNo: this.receiptNo,
          receiptSubNo: this.receiptSubNo,
          receiptChildNo: this.receiptChildNo,
          businessDomain: this.returnBusinessDomain()
        }
        http.preViewScenes(params).subscribe((res) => {
          this.causeOptions = res.data
          resolve()
        }, () => {
          this.causeOptions = []
          resolve()
        })
        this.$refs.shouhouQueryFrom.resetFields()
        if (this.targetId === 6) {
          this.afterSaleForm.moneyValidTime = 4
        } else {
          this.afterSaleForm.moneyValidTime = 400
        }
        this.isShow = false
      })
    },
    showimg(index) {
      this.$refs.viewerRef.$viewer.view(index)
    },
    delbtnpic(index) {
      this.$confirm('是否确认删除图片?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.afterSaleForm.compensateImages.splice(index, 1)
      })
    },
    handlePictureCardPreview(res) {
      if (res.errorCode === '0') {
        this.afterSaleForm.compensateImages.push(res.url)
      } else {
        this.$message.error(res.errorMsg || res.errorMessage || '文件上传失败')
      }
    },
    // 提交
    submitShouhouForm() {
      const params = Object.assign({}, this.afterSaleForm, {
        receiptNo: this.receiptNo,
        receiptSubNo: this.receiptSubNo,
        receiptChildNo: this.receiptChildNo,
        priceMoney: this.explain.priceMoney,
        uniqueId: this.explain.uniqueId,
        businessDomain: this.returnBusinessDomain(),
        compensateReasonStr: this.afterSaleForm.compensateReason
      })
      params.compensateReason = params.compensateReason.length ? params.compensateReason[params.compensateReason.length - 1] : params.compensateReason

      params.compensateMoney = this.explain.maxMoney > 0 ? Math.min(params.compensateTotalMoney, this.explain.maxMoney) : parseFloat(params.compensateTotalMoney)
      params.compensateTotalMoney = parseFloat(params.compensateTotalMoney)

      if (this.afterSaleForm.compensateType == 2) { // 手机号
        this.priceMoney = params.compensateTotalMoney
      }
      if (parseFloat(params.compensateMoney) < parseFloat(params.compensateTotalMoney)) {
        if (this.intercept) {
          this.$message.error(`标准补偿金额超出该平台下平台规则金额${params.compensateMoney}元`)
          return
        } if (this.flage) {
          this.$confirm(`补偿金额超出该原因下标准补偿金额${params.compensateMoney}元，请确认要补偿吗？`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.flage = false
            this.submitShouhouForm()
            setTimeout(() => {
              this.flage = true
            }, 2000)
          })
          return
        }
      }
      // 余额不传有效期
      if (params.compensateMode !== 0 && params.compensateMode !== 2) {
        delete params.moneyValidTime
      }
      this.saveParams = params
      this.$refs.shouhouQueryFrom.validate((valid) => {
        if (valid) {
          // 如果用户上传了图片,则需要提交前判断是否同图的接口
          if (this.afterSaleForm.compensateImages && this.afterSaleForm.compensateImages.length) {
            this.$refs.figureDialog.getData({ bizId: this.afterSaleForm.compensateImages.join(','), type: 5 })
          } else {
            this.handleSave()
          }
        }
      })
    },
    handleSave() {
      if (typeof this.sumbit === 'function') {
        const data = this.saveParams
        switch (data.compensateType) {
          case 10:
            data.compensateType = 15
            break
          default:
            break
        }
        this.sumbit(data)
        this.emptyAfterSaleForm()
        return
      }
      http.compensateApply(this.saveParams).subscribe((res) => {
        cache.removeCache({
          id: this.afterSaleForm.receiptNo + this.subOrderId,
          formId: 'newcompensate'
        })
        this.$message({ type: 'success', message: '补偿成功' })
        this.$emit('fatherMos')
      })
    },
    // 补偿单号点击, 跳到不错详情
    cellClick(row) {
      this.$emit('cellClick', row)
    },
    // 关闭清空数据
    emptyAfterSaleForm() {
      this.afterSaleForm = {
        compensateType: 1,
        receiptNo: '',
        compensateReason: '',
        compensateMoney: '',
        compensateTotalMoney: '',
        compensateMode: 2,
        moneyValidTime: null,
        compensateAccountType: 2,
        compensateDesc: '',
        compensateImages: []
      }
      this.orderObj = {
        orderItemBo: [],
        logisticsBeanList: []
      }
      this.explain = {
        ruleExplain: '',
        compensateText: '',
        guideText: '',
        compensateMode: [1, 2],
        compensateAccountType: [0, 1],
        compensateDesc: 2,
        compensateImage: 2,
        maxMoney: 0
      }
      this.receiptNo = ''
      this.receiptSubNo = ''
      this.receiptChildNo = ''
      this.compensateNum = ''
      this.buyCount = ''
      this.compensateMoney = ''
      this.isShow = false
      this.subOrderId = ''
      this.isPhone = false
      this.explainVisible = false
      this.isExplain = false
      this.itemId = ''
    },
    // 价保填入金额
    fillAmount(value) {
      this.afterSaleForm.compensateTotalMoney = value
    },
    returnBusinessDomain() {
      return this.targetId == 6 || this.targetId == 11 ? 1 : 0
    },
    // 初始化
    injectGetInfo(...args) {
      const [
        orderId,
        subOrderId,
        targetId,
        compensateReason,
        compensateMoney,
        imgList,
        solution
      ] = args
      this.afterSaleForm.receiptNo = orderId
      this.subOrderId = subOrderId
      this.targetId = targetId
      this.$refs.shouhouQueryFrom.resetFields()

      if (this.targetId === 6) {
        this.afterSaleForm.moneyValidTime = 4
      } else {
        this.afterSaleForm.moneyValidTime = 400
      }
      this.isShow = false
      // 判断补偿类型
      if (this.getIsInReturn([7040, 7041], compensateReason)) {
        this.afterSaleForm.compensateType = 3
      } else {
        this.afterSaleForm.compensateType = 1
      }
      // this.afterSaleForm.compensateReason = compensateReason
      // this.afterSaleForm.compensateMoney = compensateMoney


      this.getOrderInfo(0, subOrderId).then(() => {
        this.$nextTick(async () => {
          const cacheData = {
            receiptNo: orderId,
            compensateType: this.afterSaleForm.compensateType,
            compensateTotalMoney: compensateMoney,
            compensateReason: compensateReason
          }
          try {
            console.info(`1234: ${cacheData}`)
            await this.getCompensateApplyAutoFillPage(cacheData)
            this.afterSaleForm.compensateReason = compensateReason
            this.getCompensateReasonChange(compensateReason, false)
            this.afterSaleForm.compensateTotalMoney = compensateMoney
            this.afterSaleForm.compensateImages = imgList || []
            this.afterSaleForm.compensateDesc = solution
          } catch (e) {
            // console.log(e)
          }
        })
      })
    },
    initInfo(options) {
      const {
        // orderId,
        // subOrderId,
        receiptNo,
        receiptSubNo,
        targetId,
        compensateType,
        compensateReason
      } = options
      console.log(options, 333)
      this.afterSaleForm.receiptNo = receiptNo
      this.afterSaleForm.compensateType = compensateType
      this.subOrderId = receiptSubNo
      this.targetId = targetId
      this.$refs.shouhouQueryFrom.resetFields()

      if (this.targetId === 6) {
        this.afterSaleForm.moneyValidTime = 4
      } else {
        this.afterSaleForm.moneyValidTime = 400
      }
      this.isShow = false
      // 判断补偿类型
      if (this.getIsInReturn([7040, 7041], [compensateReason])) {
        this.afterSaleForm.compensateType = 3
      } 
      // this.afterSaleForm.compensateReason = compensateReason
      // this.afterSaleForm.compensateMoney = compensateMoney
      this.getOrderInfo(0, this.subOrderId).then(() => {
        this.$nextTick(async () => {
          // const cacheData = {
          //   receiptNo: receiptNo,
          //   compensateType: this.afterSaleForm.compensateType,
          //   compensateTotalMoney: compensateMoney,
          //   compensateReason: solution
          // }
          try {
            console.info(`compensateReason：${compensateReason}`)
            // await this.getCompensateApplyAutoFillPage(cacheData)
            // this.afterSaleForm.compensateReason = `${compensateReason}`
            this.getCompensateReasonChange([`${compensateReason}`], true)
            // this.afterSaleForm.compensateTotalMoney = compensateMoney
            // this.afterSaleForm.compensateImages = imgList || []
            // this.afterSaleForm.compensateDesc = compensateDesc
            Object.assign(this.afterSaleForm, { ...options })
          } catch (e) {
            console.log(e)
          }
        })
      })
    },
    getIsInReturn(arr, arr2) {
      if (!arr2) {
        return false
      }

      let isShow = false
      arr.forEach((i) => {
        if (arr2.indexOf(i) !== -1) {
          isShow = true
        }
      })
      return isShow
    },
    // 修复手风琴折叠效果
    handleToggle(index) {
      this.$set(this.tuShow, `isTuShow${index}`, !this.tuShow[`isTuShow${index}`])
    }
  }
}
</script>
<style lang="less">
#new-compensate {
  padding: 20px;
  background: white;
  border-top: 1px solid #dcdcdc;

  .goods-wrapper {
    margin: 10px 0;
    padding: 10px;
    border: 1px solid #dcdcdc;

    .googs_list {
      border: 1px solid #ccc;
      border-radius: 4px;
      padding: 4px 6px;

      label {
        width: 30px;
        overflow: hidden;
        margin: 5px 0 0;
        float: left;
      }

      .googs_list-right {
        display: inline-block;

        p {
          margin: 0;
          line-height: 22px;
        }
      }
    }

    .googs_table {
      width: 100%;
      border-collapse: collapse;
      border: none;

      th {
        font-weight: bold;
      }

      td {
        display: flex;
        border-top: none !important;
        border-bottom: 1px solid #ccc;

        .elradio {
          width: 30px;

          .el-radio__label {
            display: none;
          }

          i {
            cursor: pointer;
            transition: all 0.2s ease;
          }

          .active {
            transform: rotate(-90deg);
          }
        }

        .goods-info-wrapper {
          flex: 1;

          .info-wrapper-flex {
            display: flex;

            img {
              width: 50px;
              height: 50px;
              margin: 6px 10px 0;
              border: 1px solid #eee;
            }

            .goods-info {
              flex: 1;

              h4,
              p {
                margin: 0;

                label {
                  float: right;
                }
              }
            }
          }
        }
      }

      td,
      th {
        padding: 0px;
      }
    }
  }

  .rule-description {
    background: #F2F2F2;
    padding: 8px 10px;
    margin-bottom: 18px;
    border-radius: 4px;

    .rule-description-box {
      display: flex;

      .box-left {
        display: inline-block;
        width: 91px;
        text-align: right;
      }

      .box-right {
        flex: 1;

        span {
          color: red;
        }

        .box-right-money {
          font-style: inherit;
          color: #0066CC;
          float: right;
          cursor: pointer;
        }
      }
    }
  }

  .compensation-way {
    display: inline-block;
    width: 159px;
  }

  .el-upload-dragger,
  .el-upload--picture-card {
    width: 70px;
    height: 70px;
    line-height: 78px;
  }

  .imgList {
    display: inline-block;

    span {
      position: relative;
      margin-right: 5px;
    }

    .el-icon-error {
      position: absolute;
      cursor: pointer;
      right: 0;
      background: #ccc;
    }

    img {
      width: 70px;
      height: 70px;
      border-radius: 5px;
      display: inline-block;
      border: 1px solid #eee;
    }
  }

  .dialog-footer {
    text-align: center;
  }

  .explain-icon {
    float: right;
    font-size: 22px;
    padding-top: 6px;
    cursor: pointer;
  }
}

.calculate-money {
  padding: 10px;

  h6 {
    margin: 0;
  }

  .table-money {
    display: flex;

    .table-left {
      flex: 1;

      .table-left-list {
        display: inline-block;
        width: 98px;
      }

      i {
        font-style: inherit;
      }
    }

    .table-right {
      display: inline-block;
      width: 138px;

      button {
        margin-top: 47px;
      }
    }
  }
}
</style>
